import { render } from "./Invoice.vue?vue&type=template&id=6cc81cd8&scoped=true"
import script from "./Invoice.vue?vue&type=script&lang=ts"
export * from "./Invoice.vue?vue&type=script&lang=ts"

import "./Invoice.vue?vue&type=style&index=0&id=6cc81cd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6cc81cd8"

export default script